// Validación de documentos de identidad aceptados por la plataforma.
// - Cédula dominicana: 11 dígitos con dígito verificador (algoritmo Luhn de la JCE).
// - Pasaporte: 6-9 caracteres alfanuméricos (formato internacional; cubre el
//   pasaporte de EE. UU., que usa 9 caracteres, p. ej. "C03005988").
// Evita que se guarden números aleatorios como documento.

/** Cédula RD: 11 dígitos y checksum válido (permite guiones/espacios). */
export function isValidCedulaRD(raw) {
  const digits = String(raw || '').replace(/[\s-]/g, '');
  if (!/^\d{11}$/.test(digits)) return false;
  // Luhn JCE: pesos 1,2 alternados sobre los primeros 10 dígitos;
  // si el producto tiene 2 dígitos se suman entre sí (equivale a restar 9).
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let prod = Number(digits[i]) * (i % 2 === 0 ? 1 : 2);
    if (prod > 9) prod -= 9;
    sum += prod;
  }
  const check = (10 - (sum % 10)) % 10;
  return check === Number(digits[10]);
}

/** Pasaporte: 6-9 alfanumérico, con al menos un dígito (RD, EE. UU. e internacional). */
export function isValidPassport(raw) {
  const value = String(raw || '').replace(/\s/g, '').toUpperCase();
  return /^[A-Z0-9]{6,9}$/.test(value) && /\d/.test(value);
}

/**
 * Valida un documento aceptando cédula RD o pasaporte.
 * @returns {{ valid: boolean, type: 'cedula'|'passport'|null }}
 */
export function validateDocument(raw) {
  if (isValidCedulaRD(raw)) return { valid: true, type: 'cedula' };
  if (isValidPassport(raw)) return { valid: true, type: 'passport' };
  return { valid: false, type: null };
}
